// src/components/ErrorDisplay.jsx
import React from 'react';

const ErrorDisplay = ({ error, onClear }) => {
  if (!error) return null;
  
  return (
    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg relative mb-6">
      <strong className="font-bold">Error: </strong>
      <span className="block sm:inline">{error}</span>
      <button 
        className="absolute top-0 bottom-0 right-0 px-4 py-3" 
        onClick={onClear}
      >
        <span className="text-red-500 font-bold text-xl">&times;</span>
      </button>
    </div>
  );
};

export default ErrorDisplay;